module.exports = __webpack_public_path__ + "static/img/brees-2020-top-image.7bd68ef.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/brees-2020-top-image.jpg
// module id = 7z5n
// module chunks = 1